import {
  AdvisorInterface,
  AxiosResponseAdvisorWithCoordinatesInterface,
  AxiosResponseBoosterInterface,
  FilledOrbInterface,
  HexaTradingOptionsInterface,
  MinerInventoryInterface,
  MiscInventoryInterface,
  ObjectOfMapInterface,
  OrbRInterface,
  ResourceInterface,
  TemplatesOrbsRInterface,
  UserInterface,
} from '@/types/types'
import {initialAdvisor} from '@/store/fakeDataForInitial'

export interface ClueModalData {
  description?: string
  hexes?: string[]
  isROrb?: boolean
  count?: number
  text?: string
  [key: string]: unknown
}

export interface initialStateInterface {
  user: null | UserInterface
  isLoad: boolean
  hexId: string | null
  addedObject: null | {
    img: string
    id: number
    refId?: number
    kind?: 'orb' | 'miner'
    data: ObjectOfMapInterface
  }
  typeModalOfMap: string | null
  orbsType: 1 | 2 | 3 | 4 | 5
  isNeedLogin: null | 'AUTH' | 'REGISTER'
  orbs: {
    1: ObjectOfMapInterface[]
    2: ObjectOfMapInterface[]
    3: ObjectOfMapInterface[]
  }
  billboards: {inventories: OrbRInterface[]; filled: FilledOrbInterface[]}
  templatesOrbsR: TemplatesOrbsRInterface[]
  hexaTradingOptions: HexaTradingOptionsInterface
  clueForModal: {index: number; data: ClueModalData; time?: number}
  isFailLoad: boolean
  defaultOctaCoinOrb: number
  defaultOctaCoinOrbR: number
  lastCoordinatesMain: [number, number, number] | null
  lastCoordinatesAnalytics: [number, number, number] | null
  language: string
  advisors: AdvisorInterface[]
  advisor: AdvisorInterface
  advisorOnMap: AdvisorInterface | null
  advisorDashboard: AxiosResponseAdvisorWithCoordinatesInterface | null
  storeTab: 0 | 1 | 2 | number
  boosters: {isLoad: boolean; list: AxiosResponseBoosterInterface[]}
  inventories: {isLoad: boolean; list: ResourceInterface[]}
  miners: {isLoad: boolean; list: MinerInventoryInterface[]}
  misc: {isLoad: boolean; list: MiscInventoryInterface[]}
  timers: {[key: string]: number}
}

export const initialState: initialStateInterface = {
  user: null,
  isLoad: false,
  hexId: null,
  addedObject: null,
  orbs: {1: [], 2: [], 3: []},
  billboards: {inventories: [], filled: []},
  orbsType: 1,
  templatesOrbsR: [],
  isNeedLogin: null,
  hexaTradingOptions: {typeOffer: 'BUY', isMy: true, min: '', max: ''},
  typeModalOfMap: null,
  clueForModal: {index: -1, data: {description: 'подсказка'}},
  isFailLoad: false,
  defaultOctaCoinOrb: 0,
  defaultOctaCoinOrbR: 0,
  lastCoordinatesMain: null,
  lastCoordinatesAnalytics: null,
  language: 'en',
  advisors: [],
  advisor: initialAdvisor,
  advisorOnMap: null,
  advisorDashboard: null,
  storeTab: 0,
  boosters: {isLoad: false, list: []},
  inventories: {isLoad: false, list: []},
  miners: {isLoad: false, list: []},
  misc: {isLoad: false, list: []},
  timers: {},
}
